import React, { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";

export const AutoSuggest = ({ options, placeholder, isDisabled, params, stateValue, setStateValue, className, inputId, name }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const escapeRegexCharacters = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const getSuggestions = (inputValue) => {
    const escapedValue = escapeRegexCharacters(inputValue?.trim());
    if (escapedValue === "") return [];
    const regex = new RegExp("^" + escapedValue, "i");
    return options.filter((option) => regex.test(option.label));
  };

  const getSuggestionValue = (suggestion) => suggestion.label;

  const renderSuggestion = (suggestion) => <span>{suggestion.label}</span>;

  const onChange = (event, { newValue }) => {
    setStateValue({ ...stateValue, [params]: newValue });
  };

  useEffect(()=>{
    setValue(stateValue[params] || "")
  },[stateValue[params]])

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    id: inputId,
    name: name || params,
    placeholder,
    value,
    onChange,
    disabled: isDisabled,
    className:className
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
    />
  );
};
